<span class="block font-semibold text-xs margin-top-12">
  Notifications
</span>
<ul>
  <li
    Notification
    class="cursor-pointer"
    *ngFor="let notification of notifications"
    (click)="releaseNotesRoute()">
    {{notification?.message}}
  </li>
</ul>
